<crm-single-select
  [options]="options"
  [(selectedItem)]="_value"
  (selectedItemChange)="valueChange.emit($event.value)"
  [filter]="false"
  [class]="isError ? 'ng-invalid ng-dirty' : ''"
  [styleClass]="isError ? 'ng-invalid ng-dirty' : ''"
  [appendTo]="appendTo"
  sort="value:number"
  optionValue="value"></crm-single-select>
